import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Users, Check, Loader2 } from "lucide-react";

export default function DemoAccountsSettings() {
  const [enabled, setEnabled] = useState(true);
  const [emails, setEmails] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [q, setQ] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get("/demo-accounts");
      setEnabled(!!data.enabled); setEmails(data.emails || []); setUsers(data.users || []);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const toggle = (em) => setEmails((xs) => xs.includes(em) ? xs.filter((x) => x !== em) : [...xs, em]);
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/demo-accounts", { enabled, emails });
      setEnabled(data.enabled); setEmails(data.emails);
      toast.success("Demo hesap ayarları kaydedildi");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  const term = (q || "").toLocaleLowerCase("tr-TR");
  const shown = users.filter((u) => !term || (u.name || "").toLocaleLowerCase("tr-TR").includes(term) || (u.email || "").toLocaleLowerCase("tr-TR").includes(term));

  if (loading) return <p className="text-sm text-slate-400">Yükleniyor…</p>;

  return (
    <div className="space-y-4" data-testid="demo-accounts-settings">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-slate-800"><Users className="h-5 w-5 text-brand-green" /> Demo Hesapları</h2>
        <p className="mt-1 text-sm text-slate-500">Giriş ekranındaki "Demo Hesapları" bölümünü aç/kapat ve hangi kullanıcıların listeleneceğini seç. Test bitince <b>kapatın</b> — herkes yalnız kendi hesabıyla girsin.</p>
      </div>

      <div className="flex items-center gap-3 rounded-xl border border-slate-200 p-3">
        <button type="button" data-testid="demo-enabled-toggle" onClick={() => setEnabled((v) => !v)}
          className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${enabled ? "bg-brand-green" : "bg-slate-300"}`}>
          <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${enabled ? "translate-x-[22px]" : "translate-x-0.5"}`} />
        </button>
        <span className="text-sm font-semibold text-slate-700">Giriş ekranında Demo Hesapları {enabled ? "GÖSTERİLİYOR" : "GİZLİ"}</span>
      </div>

      <div className={enabled ? "" : "pointer-events-none opacity-50"}>
        <Input data-testid="demo-user-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Kullanıcı ara (ad / e-posta)" className="mb-2" />
        <div className="max-h-80 space-y-1 overflow-y-auto rounded-xl border border-slate-100 p-2">
          {shown.map((u) => {
            const on = emails.includes(u.email);
            return (
              <button key={u.email} type="button" data-testid={`demo-user-${u.email}`} onClick={() => toggle(u.email)}
                className={`flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left transition-colors ${on ? "bg-brand-green/5 ring-1 ring-brand-green/30" : "hover:bg-slate-50"}`}>
                <span className="min-w-0">
                  <span className="block truncate text-sm font-semibold text-slate-800">{u.name} <span className="text-[11px] font-medium text-slate-400">· {u.role_label}</span></span>
                  <span className="truncate text-[11px] text-slate-400">{u.email}{u.is_active ? "" : " · pasif"}</span>
                </span>
                <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${on ? "border-brand-green bg-brand-green text-white" : "border-slate-300"}`}>{on ? <Check className="h-3 w-3" /> : null}</span>
              </button>
            );
          })}
          {shown.length === 0 && <p className="p-3 text-center text-xs text-slate-400">Kullanıcı bulunamadı.</p>}
        </div>
        <p className="mt-1 text-[11px] text-slate-400">Seçili: {emails.length} · Not: tek-tık giriş yalnız demo şifresini (Groot!2026) kullanan hesaplarda çalışır.</p>
      </div>

      <Button data-testid="demo-save" onClick={save} disabled={saving} className="bg-brand-green text-white hover:bg-brand-green-600">
        {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Check className="mr-2 h-4 w-4" />} Kaydet
      </Button>
    </div>
  );
}
